import React from 'react';
import './ourServices.scss';

const EstrategiaNegocioServices = () => {
  return (
    <div className="our-services">
      <div className="our-services__container">
        <div className="our-services__content">
          <h2 className="our-services__title">
            Evaluación y Mejora Continua con BI
          </h2>
          <div className="our-services__title-line" />
          <p className="our-services__text">
            Monitorizamos y optimizamos proyectos creativos en tiempo real
            mediante Business Intelligence y análisis neuropsicológico continuo.
          </p>
          <p className="our-services__text">
            Ofrecemos un servicio continuo de evaluación y retroalimentación
            para proyectos en curso. Utilizamos Business Intelligence para
            monitorear y analizar el progreso de los proyectos creativos,
            proporcionando insights en tiempo real que permiten ajustes rápidos
            y basados en evidencia científica.
          </p>
          <p className="our-services__text">
            Nuestro sistema de seguimiento garantiza la calidad y coherencia del
            proyecto a lo largo de todo su desarrollo, desde la preproducción
            hasta la distribución, asegurando que cada decisión esté respaldada
            por datos reales y conocimiento neuropsicológico.
          </p>
        </div>
        <div className="our-services__solutions">
          <h3 className="our-services__subtitle">
            Entre nuestras soluciones se incluyen:
          </h3>
          <ul className="our-services__list">
            <li className="our-services__item">
              <p className="our-services__item-title">
                Dashboard de seguimiento en tiempo real
              </p>
              <p className="our-services__item-desc">
                Paneles visuales e interactivos que permiten monitorizar el
                estado y evolución del proyecto en cada fase de producción.
              </p>
            </li>
            <li className="our-services__item">
              <p className="our-services__item-title">
                Informes periódicos neuropsicológicos
              </p>
              <p className="our-services__item-desc">
                Entregamos informes detallados con insights sobre el impacto
                emocional, la coherencia narrativa y el rendimiento del equipo.
              </p>
            </li>
            <li className="our-services__item">
              <p className="our-services__item-title">
                Detección temprana de problemas
              </p>
              <p className="our-services__item-desc">
                Identificamos desviaciones y problemas en la producción antes de
                que escalen, permitiendo una respuesta ágil y eficaz.
              </p>
            </li>
            <li className="our-services__item">
              <p className="our-services__item-title">
                Optimización continua basada en datos
              </p>
              <p className="our-services__item-desc">
                Ajustamos la estrategia creativa y productiva de forma
                iterativa, garantizando la mejora constante a lo largo del
                proyecto.
              </p>
            </li>
            <li className="our-services__item">
              <p className="our-services__item-title">
                Aseguramiento de calidad y coherencia
              </p>
              <p className="our-services__item-desc">
                Velamos por la integridad narrativa, emocional y técnica del
                proyecto desde el inicio hasta su entrega final.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default EstrategiaNegocioServices;
